import releaseNotes from '@/release-notes/release-notes.json';
import { DateTime } from 'luxon';
import { computed } from 'vue';

export default function useReleaseNotes(personalAppSettingsSvc, loggedInUser) {
  const unreadReleaseNotes = computed(() => {
    if (!Array.isArray(personalAppSettingsSvc.personalAppSettings.value.readReleaseNotes)) {
      return [];
    }

    if (loggedInUser.value.personalInfosCompleted === null) {
      return [];
    }

    const firstLoginUser = DateTime.fromISO(loggedInUser.value.personalInfosCompleted);

    return releaseNotes.filter((d) => {
      const date = DateTime.fromISO(d.id);
      if (date.diff(firstLoginUser) < 0) {
        return false;
      }

      return !personalAppSettingsSvc.personalAppSettings.value.readReleaseNotes.includes(d.id);
    });
  });

  const markAsRead = () => personalAppSettingsSvc.updateSingle(
    {
      uid: personalAppSettingsSvc.personalAppSettings.value.uid,
      readReleaseNotes: releaseNotes.map((n) => n.id),
    },
  );

  return { unreadReleaseNotes, markAsRead };
}
